// src/util/merge.ts
import deepMerge from "deepmerge";
var merge = function merge(dst, src) {
  return deepMerge(dst, src || {}, {
    arrayMerge: function arrayMerge(destinationArray, sourceArray) {
      return sourceArray;
    }
  });
};
export { merge };